export type SourceProductId = "sa" | "pss";

export interface SourceProductConfig {
  id: SourceProductId;
  labelId: string;
}

export const SOURCE_PRODUCTS: SourceProductConfig[] = [
  {
    id: "sa",
    labelId: "app.toolboxChat.sources.product.systemAdministration",
  },
  {
    id: "pss",
    labelId: "app.toolboxChat.sources.product.planningSelfStudy",
  },
];

const SOURCE_PRODUCT_IDS = SOURCE_PRODUCTS.map((product) => product.id);

export const extractSourceIdFromToolArgs = (
  args: string,
): SourceProductId | null => {
  try {
    const parsed = JSON.parse(args);
    if (SOURCE_PRODUCT_IDS.includes(parsed.source)) {
      return parsed.source as SourceProductId;
    }
  } catch {}
  return null;
};

export const resolveSourceProducts = (
  sourceIds: SourceProductId[],
): SourceProductConfig[] =>
  SOURCE_PRODUCTS.filter((product) => sourceIds.includes(product.id));
